// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 856) return "assets/js/856.js";
	if (chunkId === 494) return "assets/js/494.js";
	// return url for filenames based on template
	return undefined;
};